
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Minibusonrentinpune() {



    const cardData =
    {
        keyword: 'Mini Bus On Rent in Pune',
        heading: 'Platinum24 Cabs: Mini Bus On Rent in Pune',
        headingDescription: ' Platinum24 Cabs offers convenient Mini Bus on Rent in Pune, perfect for medium-sized groups traveling for family outings, corporate events, school trips, or religious tours. Our fleet of 17, 20, and 25-seater AC and non-AC minibuses ensures spacious seating, strong air-conditioning, and ample luggage space for a comfortable journey. With professional chauffeurs, timely service, and affordable rental packages, we make group travel hassle-free and enjoyable. Whether it’s a weekend getaway, an outstation tour, or a multi-day trip, Platinum24 Cabs guarantees safe, reliable, and comfortable mini bus rental service in Pune.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s iconic fort palace. Once the seat of the Maratha Empire, its massive gates, fountains, and ruins narrate tales of grandeur. Though destroyed by fire in 1828, it still draws thousands of visitors. The evening light-and-sound show recreates the legacy of Bajirao and Mastani. Tourists love exploring its historic courtyards and gardens. Shaniwar Wada is Pune’s proud heritage symbol."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace, built in 1892, is a majestic monument associated with India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and other leaders were imprisoned here during the Quit India Movement. Today, it houses a museum showcasing Gandhi’s belongings and photographs. The Italian arches and sprawling lawns add architectural beauty. It is also a memorial to Kasturba Gandhi. Aga Khan Palace is Pune’s historical and inspirational landmark."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is famous for the 1670 battle where Tanaji Malusare fought bravely for Chhatrapati Shivaji Maharaj. The fort offers trekking trails, temples, and panoramic views of the Sahyadris. In monsoon, mist and waterfalls make the climb enchanting. Visitors also enjoy local delicacies like pithla-bhakri at the fort. It is a blend of adventure and history. Sinhagad is Pune’s must-visit trekking and heritage spot."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most famous shrine dedicated to Lord Ganesha. The magnificent idol is adorned with gold and jewels. During Ganesh Chaturthi, the temple becomes the center of grand festivities with thousands of devotees. The temple is also known for its charitable activities. It is a spiritual and cultural icon of the city. Dagdusheth Ganpati is Pune’s divine and cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. The temple features massive stone pillars, a sanctum, and a Nandi mandapa. Despite being in the city center, it offers peace and spirituality. Its architecture reflects ancient Indian craftsmanship. Evening chants create a mystical aura. Pataleshwar is Pune’s hidden spiritual gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar. Exhibits include ornaments, sculptures, musical instruments, and everyday antiques. The recreated Mastani Mahal is a highlight. It is an educational and fascinating spot for history enthusiasts. The museum preserves Indian traditions across centuries. It is Pune’s cultural treasure house."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest heritage sites, offering panoramic views of the city. At its summit stands the Parvati Temple dedicated to Lord Shiva and Goddess Parvati. Built during the Peshwa era, it also houses museums and smaller shrines. Climbing 103 steps to the top is both devotional and adventurous. Sunrise and sunset views here are mesmerizing. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is Pune’s global center for wellness and spirituality. Spread across lush gardens, it attracts seekers worldwide. It offers meditation, yoga sessions, and personal growth workshops. The ashram’s Zen gardens and serene meditation halls provide tranquility. It is ideal for rejuvenation and mindfulness. Osho Ashram is Pune’s international hub of peace and harmony."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. Flowing streams, stone bridges, and manicured lawns make it a peaceful retreat. Families enjoy strolls, photography, and picnics here. The garden represents Indo-Japanese cultural friendship. Seasonal flowers enhance its beauty year-round. Pu La Deshpande Garden is Pune’s green oasis of calm."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a favorite weekend destination near Pune. It supplies water to the city while offering picturesque landscapes. During monsoon, the overflowing dam becomes a spectacular sight. Street food stalls selling corn and tea make it lively. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural getaway."
  }
],



      "services": [
    {
      "name": "Mini Bus Rental Pune",
      "description": "Dependable and comfortable mini bus rental services in Pune, perfect for small to medium-sized groups looking for convenient transportation. Our mini buses are well-maintained, air-conditioned, and equipped with comfortable seating to ensure a pleasant travel experience. Ideal for family outings, group tours, school trips, and corporate events, our rentals come with flexible pricing and customizable rental durations to fit your needs."
    },
    {
      "name": "Pune Mini Bus On Rent",
      "description": "Quick and hassle-free mini bus rental in Pune with instant booking confirmation. Whether you need a mini bus for a day trip, local commute, or multi-day journey, our fleet of reliable mini buses and experienced drivers ensure a safe and timely travel experience. We cater to personal, corporate, and event-based travel requirements with personalized service and competitive rates."
    },
    {
      "name": "Rent Mini Bus Pune",
      "description": "Easily rent a mini bus in Pune for any occasion, from school excursions to corporate travel and family getaways. Our rental services provide clean, sanitized vehicles with spacious interiors and safety features. Enjoy flexible pick-up and drop-off locations along with professional drivers who prioritize your comfort and security."
    },
    {
      "name": "Mini Bus Hire Pune",
      "description": "Affordable and reliable mini bus hire service in Pune tailored for group travel. Our mini buses accommodate various group sizes and come with modern amenities such as air conditioning, ample luggage space, and comfortable seating arrangements. Ideal for weddings, corporate outings, sightseeing tours, and more, with transparent pricing and 24/7 customer support."
    },
    {
      "name": "Affordable Mini Bus Rental Pune",
      "description": "Get budget-friendly mini bus rental options in Pune without compromising on quality or safety. We offer competitive pricing plans designed for different group sizes and travel durations. Our mini buses are regularly maintained, GPS-enabled, and driven by professional chauffeurs to guarantee a seamless journey."
    },
    {
      "name": "Mini Bus Booking Pune",
      "description": "Book your mini bus in Pune instantly with our easy-to-use platform. Choose from a wide range of mini bus models to suit your travel needs, whether for short city trips or long-distance travel. Our booking system offers flexible schedules, transparent fare structures, and round-the-clock customer service to assist you anytime."
    },
    {
      "name": "Mini Bus Service Pune",
      "description": "Comprehensive mini bus services in Pune catering to varied travel demands, including airport transfers, group tours, corporate travel, and school trips. Our fleet is equipped with modern safety features and amenities to make your journey smooth and enjoyable. Dedicated customer care ensures a hassle-free travel experience from start to finish."
    },
    {
      "name": "Mini Bus for Group Travel Pune",
      "description": "Specialized mini bus rentals for group travel in Pune, designed to accommodate friends, families, corporate teams, and event participants. Our spacious mini buses ensure everyone travels together comfortably with sufficient luggage space. Customized routes and flexible rental periods available to match your itinerary perfectly."
    },
    {
      "name": "Pune Mini Bus Rent Charges",
      "description": "Transparent and competitive mini bus rental charges in Pune with no hidden fees. Rates depend on bus size, rental duration, and distance covered. We provide detailed fare breakdowns including driver allowance, fuel, and toll charges, enabling you to plan your budget effectively and choose the best deal for your travel."
    },
    {
      "name": "Mini Bus with Driver Pune",
      "description": "Hire mini buses with experienced and professional drivers in Pune who ensure your safety and timely arrival at all destinations. Our drivers are familiar with local traffic conditions and preferred routes, providing courteous and efficient service. Enjoy stress-free travel with our chauffeur-driven mini bus options."
    },
    {
      "name": "Mini Bus for Corporate Trips Pune",
      "description": "Premium mini bus rental services in Pune tailored for corporate trips, employee transport, conferences, and business events. Our mini buses are equipped with amenities like Wi-Fi, charging ports, and comfortable seating to keep your team productive and relaxed while on the move. Flexible packages and reliable service make us a preferred choice for corporate clients."
    },
    {
      "name": "Mini Bus for School Trips Pune",
      "description": "Safe and trustworthy mini bus rental for school trips in Pune, with specially trained drivers and vehicles that comply with all safety regulations. Our buses offer comfortable seating, seat belts, and regular maintenance checks to ensure the well-being of students during excursions, sports events, or educational tours."
    },
    {
      "name": "Mini Bus for Family Trips Pune",
      "description": "Ideal mini bus rental options in Pune for family trips, reunions, and celebrations. Our mini buses provide ample space, comfort, and safety features to accommodate families of various sizes. Enjoy hassle-free planning with flexible schedules, door-to-door service, and affordable rates tailored for family travel."
    },
    {
      "name": "Mini Bus Rental for Weddings Pune",
      "description": "Specialized mini bus rental for weddings and related events in Pune. Transport your guests comfortably and punctually with our well-maintained mini buses driven by professional chauffeurs. Our services include customized pick-up/drop-off plans, special event coordination, and premium amenities to make wedding transportation seamless and elegant."
    },
    {
      "name": "Pune Mini Bus Rental Packages",
      "description": "Flexible mini bus rental packages in Pune designed to cater to different group sizes and travel durations. Choose from hourly, daily, or multi-day plans with transparent pricing and inclusive services such as driver allowance, fuel, and tolls. Our packages ensure you get the best value and customized experience for your group transportation needs."
    }
  ],
  "tableData": [
    ["Mini Bus Rental Pune", "Pune Mini Bus On Rent"],
    ["Rent Mini Bus Pune", "Mini Bus Hire Pune"],
    ["Affordable Mini Bus Rental Pune", "Mini Bus Booking Pune"],
    ["Mini Bus Service Pune", "Mini Bus for Group Travel Pune"],
    ["Pune Mini Bus Rent Charges", "Mini Bus with Driver Pune"],
    ["Mini Bus for Corporate Trips Pune", "Mini Bus for School Trips Pune"],
    ["Mini Bus for Family Trips Pune", "Mini Bus Rental for Weddings Pune"],
    ["Pune Mini Bus Rental Packages", "—"]
  ],


           "whychoose": [
    {
      "WhyChooseheading": "Mini Bus on Rent in Pune for Comfortable Group Travel",
      "WhyChoosedescription": "Platinum24 Cabs provides clean, spacious, and reliable mini buses on rent in Pune for all kinds of group journeys."
    },
    {
      "WhyChooseheading": "Perfect for Weddings, Picnics, Corporate Events & School Trips",
      "WhyChoosedescription": "Our mini buses are ideal for both short and long-distance group travel in and around Pune."
    },
    {
      "WhyChooseheading": "Seating Capacity Ranging from 13 to 32 Seats",
      "WhyChoosedescription": "Choose the right mini bus size based on your group size and comfort needs."
    },
    {
      "WhyChooseheading": "Fully Air-Conditioned with Comfortable Pushback Seats",
      "WhyChoosedescription": "Enjoy a relaxed ride with AC, cushioned seating, and ample space for luggage."
    },
    {
      "WhyChooseheading": "Well-Trained Drivers Ensuring Safety and Punctuality",
      "WhyChoosedescription": "Our experienced drivers ensure a smooth, safe, and timely journey every time."
    },
    {
      "WhyChooseheading": "Affordable Rental Packages with No Hidden Costs",
      "WhyChoosedescription": "Get transparent pricing that includes fuel, tolls, and driver charges—no surprises later."
    },
    {
      "WhyChooseheading": "Available for Local and Outstation Trips",
      "WhyChoosedescription": "Whether you're traveling within Pune or planning an outstation trip, our mini buses are ready."
    },
    {
      "WhyChooseheading": "Easy Booking Process and 24/7 Customer Support",
      "WhyChoosedescription": "Book your mini bus online or by phone and get assistance anytime from our dedicated team."
    }
  ]






















    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs offer mini bus rentals in Pune?',
        answer: 'Yes, Platinum24 Cabs provides mini bus rentals in Pune, ideal for small group travel and events.',
    },
    {
        question: 'How can I book a mini bus on rent in Pune with Platinum24 Cabs?',
        answer: 'You can book a mini bus easily through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What is the seating capacity of the mini buses available for rent?',
        answer: 'Our mini buses typically accommodate 15 to 25 passengers, perfect for small to medium-sized groups.',
    },
    {
        question: 'Are the mini buses well-maintained and comfortable?',
        answer: 'Yes, all mini buses are regularly serviced, clean, and equipped with comfortable seating for a pleasant journey.',
    },
    {
        question: 'Can I hire a mini bus for local Pune travel as well as outstation trips?',
        answer: 'Absolutely! We offer mini bus rentals for both local trips within Pune and long-distance travel.',
    },
    {
        question: 'What rental packages are available for mini buses in Pune?',
        answer: 'We provide flexible hourly, daily, and multi-day rental packages tailored to your travel requirements.',
    },
    {
        question: 'Do mini bus rentals come with drivers?',
        answer: 'Yes, all mini bus rentals include professional and experienced drivers for your safety and convenience.',
    },
    {
        question: 'Are safety and hygiene protocols followed for mini bus rentals?',
        answer: 'Yes, our mini buses are regularly sanitized, and drivers follow strict safety guidelines to ensure passenger well-being.',
    },
    {
        question: 'Is corporate mini bus rental available in Pune?',
        answer: 'Yes, Platinum24 Cabs offers customized corporate mini bus rental services with priority support and flexible billing options.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Manish Deshmukh',
        feedback: 'The mini bus rental from Platinum24 Cabs in Pune was perfect for our corporate outing. Comfortable and timely service.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Priya Kulkarni',
        feedback: 'Great experience renting a mini bus. The vehicle was clean and the driver was very professional.',
        rating: 5,
    },
];


































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];









const miniBusOnRentPuneSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mini Bus On Rent in Pune",
  "image": "https://www.platinum24cab.com/assets/images/mini-bus-pune.jpg",
  "description": "Rent mini buses in Pune for group travel, corporate trips, school events, weddings, and family outings. Affordable mini bus rental with driver at Platinum24 Cabs.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/mini-bus-on-rent-pune"
  }
};





    return (
        <div>
<Helmet>
  <title>Mini Bus On Rent in Pune | Group & Corporate Mini Bus Rental | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Rent mini buses in Pune for group travel, corporate trips, school events, weddings, and family outings. Affordable mini bus rental with driver at Platinum24 Cabs."
  />
  <meta
    name="keywords"
    content="Mini Bus Rental Pune, Pune Mini Bus On Rent, Rent Mini Bus Pune, Mini Bus Hire Pune, Affordable Mini Bus Rental Pune, Mini Bus Booking Pune, Mini Bus Service Pune, Mini Bus for Group Travel Pune, Pune Mini Bus Rent Charges, Mini Bus with Driver Pune, Mini Bus for Corporate Trips Pune, Mini Bus for School Trips Pune, Mini Bus for Family Trips Pune, Mini Bus Rental for Weddings Pune, Pune Mini Bus Rental Packages"
  />
  <script type="application/ld+json">
    {JSON.stringify(miniBusOnRentPuneSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/22.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Minibusonrentinpune;